import React from 'react';
import styled from '@emotion/styled';

interface IColumnInRowCard {
  imageName: string;
  header: string;
  description: string;
  count?: number;
  noBgColor?: boolean;
}

const ColumnInRowCard: React.FC<IColumnInRowCard> = ({
  imageName,
  header,
  description,
  count,
  noBgColor
}) => {
  const formattedCount = count ? (count < 10 ? `0${count}` : `${count}`) : '';

  return (
    <Container className={noBgColor ? 'noBgColor' : ''}>
      <Top>
        <IconWrapper>
          <Img src={`/static/img/${imageName}.png`} alt={header} />

        </IconWrapper>
        <CountOverlay>{formattedCount}</CountOverlay>
      </Top>
      <Header>{header}</Header>
      <Description>{description}</Description>
    </Container>
  );
};

export default ColumnInRowCard;

const Container = styled.div`
width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 40px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  background-color: #ffffff;
  border-radius: 12px;
  min-width: 320px;
  max-width: 410px;
  text-align: center;
  gap: 16px;
  transition: transform 0.2s ease-in-out;

    &.noBgColor {
    background-color: transparent;
    padding: 20px;
    gap: 12px;
  }

  &:hover {
    transform: translateY(-5px);
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 350px;
    margin-bottom: 20px;
  }
`;

const Top = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const IconWrapper = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #FFEEF2;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;

const Img = styled.img`
  width: 40px;
  height: 40px;
  object-fit: contain;
`;

const CountOverlay = styled.div`
  font-size: 60px;
  font-weight: 800;
  color: #FFEEF2;
`;

const Header = styled.h3`
  width: 100%;
  text-align: left;
  color: #000000;
  font-weight: 700;
  font-size: 24px;
  margin: 0;
  line-height: 1.3;
`;

const Description = styled.p`
  width: 100%;
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  color: #00000099;
  margin: 0;
  line-height: 1.5;
`;